import _ from "lodash";
import * as z from "../../framework";

export function apply(options) {
    options = options || {};

    var listItemSelector = options.listItemSelector || "#HamburgerMenu li";
    var rights = options.rights || [];
    var removeToolbarItems = options.removeToolbarItems == undefined
        ? true
        : options.removeToolbarItems;
    var firstListItemVisibleBeforeRightsApplied = $(listItemSelector).first();

    $.each(rights, function (index, menuItem) {
        var userHasRight = _.includes(z.user.companyData.Rights, menuItem.right);

        if (!userHasRight) {
            $(menuItem.selector).remove();
        }
    });

    var listItems = $(listItemSelector);
    if (listItems.length === 0) {
        // ReSharper disable once ConditionIsAlwaysConst
        if (removeToolbarItems) {
            $(".toolbar-inset, .breadcrumb").remove();
        }
    } else {
        var firstListItemCurrentlyVisible = listItems[0];

        if ($(firstListItemCurrentlyVisible).attr("id") !== $(firstListItemVisibleBeforeRightsApplied).attr("id")) {
            (firstListItemCurrentlyVisible as HTMLElement).click();
        }
    }
}
